import { Component } from '@angular/core';

@Component({
  selector: 'sp-user-main',
  templateUrl: './user-main.component.html',
  standalone: false
})
export class UserMainComponent {

}
